import { render, staticRenderFns } from "./SliceProjectImage.vue?vue&type=template&id=1d1a0bc1&lang=pug&"
import script from "./SliceProjectImage.vue?vue&type=script&lang=js&"
export * from "./SliceProjectImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports